import { FC } from 'react'
import { useDateTime } from '../../../shared/useDateTime'
import { useAuth } from '../../../context/auth-context'
import { useTranslation } from 'react-i18next'
import PerText from '../../../components/custom_components/Text'
import PerIcon from '../../../components/custom_components/Icon'
import PerFlexRow from '../../../components/custom_components/FlexRow'
import { MeetingDashboardFragment, EmployeeDisplayFragment, EmployeeDisplayShortInfo } from '../../../types'
import { PerInfoBoxMeetingElement } from '../../../components/custom_components/InfoBox/InfoBoxMeetingElement'
import ManagerMeetingActionButton from '../../dashboard/Table/ManagerMeetingActionButton'

interface FutureMeetingElementProps {
  meetingData: MeetingDashboardFragment[]
}

export const FutureMeetingElement: FC<FutureMeetingElementProps> = ({ meetingData }) => {
  const { user } = useAuth()
  const { utcDateStringToMoment, isAfterNowWithMargin } = useDateTime(user)
  const [t] = useTranslation()

  // get data of temporally closest meeting
  const nextMeetingData = [...meetingData]
    .filter((meeting) => isAfterNowWithMargin(meeting.displayDate))
    .sort((a, b) => {
      const date1 = utcDateStringToMoment(a.displayDate.valueOf())
      const date2 = utcDateStringToMoment(b.displayDate.valueOf())
      return date1 && date2 && date1.isBefore(date2) ? -1 : date1 && date2 && date1.isAfter(date2) ? 1 : 0
    })
    .shift()

  return (
    <>
      {nextMeetingData ? (
        <PerInfoBoxMeetingElement
          meeting={{
            displayDate: nextMeetingData.displayDate,
            status: nextMeetingData.status,
            type: nextMeetingData.type,
            reviewer: nextMeetingData.reviewer as EmployeeDisplayShortInfo,
            employee: nextMeetingData.employee as EmployeeDisplayFragment,
          }}
          user={user}
          actionButton={<ManagerMeetingActionButton meeting={nextMeetingData} type="rectangular" />}
        />
      ) : (
        // if there are no future meetings, but meetings in the past show appropriate text and reschedule icon
        <PerFlexRow className="nowrap">
          <PerIcon name="rescedule_fill" color="error" size={24} />
          <PerText ml="xxs">{t('meetingView.managerMeetings.elapsedMeetingsAvailableHeader')}</PerText>
        </PerFlexRow>
      )}
    </>
  )
}
